<template>
  <div class="wt-text-overlay-page">
    <layout-general>
      <layout-header slot="header" />
      <text-overlay-top-bar slot="top"></text-overlay-top-bar>
      <main-stage slot="main" @click.native.right="onclickRightMouse">
        <transition name="ae-fade">
          <div
            class="-right-click-panel"
            :style="menuStyle"
            v-if="menuActive"
            v-click-outside="closeMenu"
          >
            <ul>
              <li class="wt2-sg">
                <wt-button
                  class="-smaller-font -min-width-unset -custom"
                  @click="triggerPaste"
                  icon="wticon-paste"
                  type="transparent"
                  text="Paste text-box"
                />
              </li>
            </ul>
          </div>
        </transition>
        <text-overlay-stage
          ref="text"
          :active="true"
          :primary="true"
        ></text-overlay-stage>
      </main-stage>
      <text-overlay-left-bar slot="left"></text-overlay-left-bar>
      <text-overlay-timeline slot="bottom"></text-overlay-timeline>
      <text-overlay-apply-cancel slot="footer"></text-overlay-apply-cancel>
    </layout-general>
  </div>
</template>

<script>
import LayoutGeneral from 'AssetEditor/layouts/LayoutGeneral.vue';
import LayoutHeader from 'AssetEditor/layouts/LayoutHeader.vue';
import TextOverlayApplyCancel from 'AssetEditor/functionality/TextOverlay/TextOverlayApplyCancel.vue';
import TextOverlayTimeline from 'AssetEditor/functionality/TextOverlay/TextOverlayTimeline.vue';
import TextOverlayTopBar from 'AssetEditor/functionality/TextOverlay/TextOverlayTopBar.vue';
import TextOverlayLeftBar from 'AssetEditor/functionality/TextOverlay/TextOverlayLeftBar.vue';
import TextOverlayStage from 'AssetEditor/functionality/TextOverlay/TextOverlayStage.vue';
import MainStage from 'AssetEditor/functionality/Stage/MainStage.vue';
import bus from 'v/AssetEditor/AssetEditorEventBus';

export default {
  components: {
    TextOverlayTopBar,
    LayoutHeader,
    LayoutGeneral,
    TextOverlayApplyCancel,
    TextOverlayTimeline,
    TextOverlayLeftBar,
    TextOverlayStage,
    MainStage,
  },

  data() {
    return {
      menuActive: false,
      menuStyle: null,
    };
  },

  methods: {
    onclickRightMouse(e) {
      const text = this.$refs.text;
      const textEl = text && text.$el;

      // if it's from text box, should open browser menu
      if (textEl && textEl.contains(e.target)) {
        this.closeMenu();
        return;
      }

      e.preventDefault();
      // toggle menuActive like real right click menu behavior
      this.menuActive = !this.menuActive;
      // only if active, set dimensions
      if (this.menuActive) {
        this.menuStyle = {
          left: `${e.pageX}px`,
          top: `${e.pageY}px`,
        };
      }
    },

    closeMenu() {
      this.menuActive = false;
    },

    triggerPaste() {
      const item = sessionStorage.getItem('application/toCopy');
      const e = new ClipboardEvent('paste');

      if (!item) {
        return;
      }

      Object.defineProperty(e, 'clipboardData', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: {
          getData() {
            return item;
          },
        },
      });

      bus.$emit('paste', e);
      this.closeMenu();
    },
  },
};
</script>
